<template>
<div class="page_bank">
    <div class="list_wrap" v-if="dataList">
        <div class="list" v-for="item in dataList" :key="item.id">
            <div class="item" @click="editBank(item)">
                <div class="name">{{item.opening_bank}}</div>
                <div class="number">
                    <div class="number_item">
                        <div class="square"></div>
                        <div class="square"></div>
                        <div class="square"></div>
                        <div class="square"></div>
                    </div>
                    <div class="number_item">
                        <div class="square"></div>
                        <div class="square"></div>
                        <div class="square"></div>
                        <div class="square"></div>
                    </div>
                    <div class="number_item">
                        <div class="square"></div>
                        <div class="square"></div>
                        <div class="square"></div>
                        <div class="square"></div>
                    </div>
                    <div class="number_item">{{ item.num }}</div>
                </div>
            </div>
        </div>
    </div>
    <!-- 添加银行卡 -->
    <div class="action_add" @click="addBank">添加银行卡</div>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SELECTBANK
} from "../../../../.././vuex/mutation_types";
import PageSearch from "../../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    data() {
        return {
            canSelect: this.$route.query.canSelect,
            loading: false,
            finished: false,
            dataList: null, // 数据
            token: null
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    naviTitle: "银行卡管理"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler("sdjy://common/refreshPage", (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('success');
            });
        } else {
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var params = {
                token: this.token,
            }
            this.$api.my.bankList(params).then(res => {
                if (res.code == 200) {
                    var arr = res.result
                    var newList = []
                    for (let i = 0; i < arr.length; i++) {
                        var bank = arr[i];
                        var num = bank.card_number
                        num = num.substring(num.length-4)
                        bank.num = num
                        newList.push(bank)
                    }
                    this.dataList = newList
                }

            })
        },
        addBank() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/bank/add'
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    name: 'bank-add'
                })
            }
        },
        editBank(item) {
            if (this.canSelect == 1) {
                this.selectBank(item)
                return
            }
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/bank/add?bankId=' + item.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/bank/add',
                    query: {
                        bankId: item.id
                    }
                })
            }
        },
        selectBank (item) {
            if (this.canSelect == 1) {
                // if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                //     var params = {
                //         'data': {
                //             'key': 'selectBank',
                //             'value': JSON.stringify(item)
                //         }
                //     }
                //     this.$bridge.callhandler('sdjy://public/saveInfo', params, (data) => {
                //         //返回上级页面
                //         var params = {
                //             'data': {}
                //         }
                //         this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                //         })
                //     })

                // } else {
                    console.log('commit_bank',JSON.stringify(item))
                    this.$store.commit(SELECTBANK, {
                        select_bank: JSON.stringify(item)
                    });
                    this.$router.back()
                // }
            }
        },
        deleteBank(item) {
            var params = {
                token: this.token,
                id: item.id
            }
            this.$api.my.bankDelete(params).then(res => {
                if (res.code == 200) {
                    this.getData()
                }
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page_map {
    background: transparent;
}
</style>
